<template>
  <div class="select-input-wrap">
    <el-form ref="selectInputRef" :model="tfContent" :rules="rules">
      <el-form-item prop="name_rule" style="margin-bottom: 0px">
        <el-input v-model="tfContent.name_rule" :placeholder="placeholder" @input="changeName"></el-input>
      </el-form-item>
      <ul class="name-list">
        <li
          v-for="(item, index) of showAdList"
          :key="index"
          :class="['name-item', selectItem.indexOf(index) === -1 ? '' : 'cur']"
          @click="handleSelectItem(item, index)"
        >
          {{ item }}
        </li>
        <li class="show-more">
          <span v-show="!showMore" @click="showMore = true">更多<i class="el-icon-arrow-down"></i></span>
          <span v-show="showMore" @click="showMore = false">收起<i class="el-icon-arrow-up"></i></span>
        </li>
      </ul>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "SelectInput",
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
    more: {
      type: Boolean,
      default: false,
    },
    value: {
      value: String,
      default: "",
    },
    placeholder: {
      value: String,
      default: "请输入",
    },
  },
  data(props) {
    return {
      showMore: props.more,
      tfContent: {
        name_rule: "",
      },
      selectItem: [],
      adGroupList: props.dataList,
      rules: {
        name_rule: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    handleSelectItem(item, itemIndex) {
      let index = this.selectItem.findIndex((item) => item === itemIndex);
      if (index === -1) {
        // this.selectItem.push(itemIndex);
        this.tfContent.name_rule += "{" + item + "}";
      } else {
        // this.selectItem.splice(index, 1);
        this.tfContent.name_rule = this.tfContent.name_rule.replace("{" + item + "}", "");
      }
      this.changeName(this.tfContent.name_rule);
    },
    changeName(data) {
      this.$emit("input", data);
    },
    checkData() {
      return new Promise((resolve, reject) => {
        this.$refs.selectInputRef.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            reject();
          }
        });
      });
    },
  },
  computed: {
    showAdList() {
      if (!this.showMore) {
        return this.adGroupList.slice(0, 5);
      }
      return this.adGroupList;
    },
  },
  watch: {
    value(val) {
      this.tfContent.name_rule = val;
    },
    tfContent: {
      //修改选择状态
      handler(value) {
        let nameRule = value.name_rule;
        let matchArr = nameRule.match(/{(.*?)}/g);
        if (matchArr) {
          let nameArr = matchArr.map((item) => item.replace(/{|}/g, ""));
          this.selectItem = [];
          nameArr.forEach((name) => {
            let lightIndex = this.adGroupList.findIndex((item) => item === name);
            if (lightIndex !== -1) {
              this.selectItem.push(lightIndex);
            }
          });
        } else {
          this.selectItem = [];
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
.select-input-wrap {
  .name-list {
    padding: 12px 0px 0px 0px;
    margin: 0px;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    .name-item {
      border-radius: 2px;
      border: 1px solid transparent;
      box-sizing: border-box;
      background: rgba(233, 233, 233, 0.6);
      color: rgba(0, 0, 0, 0.85);
      font-size: 12px;
      padding: 2px 6px;
      margin: 0 8px 8px 0px;
      cursor: pointer;
      &.cur {
        border: 1px solid rgba(24, 144, 255, 1);
        background: rgba(225, 240, 255, 1);
        color: rgba(24, 144, 255, 1);
      }
    }
    .show-more {
      color: rgba(24, 144, 255, 1);
      font-size: 13px;
      cursor: pointer;
      margin-left: 20px;
      line-height: 24px;
      i {
        margin-left: 4px;
      }
    }
  }
}
</style>
